import { Route, Routes } from "react-router-dom";
import PrepaymentCreateScreen from "screens/App/CRM/Payment/Prepayment/PrepaymentCreateScreen";
import PrepaymentDetailScreen from "screens/App/CRM/Payment/Prepayment/PrepaymentDetailScreen";
import PrepaymentEditScreen from "screens/App/CRM/Payment/Prepayment/PrepaymentEditScreen";
import PrepaymentListScreen from "screens/App/CRM/Payment/Prepayment/PrepaymentListScreen";

const PrepaymentRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<PrepaymentListScreen />} />
      <Route path="create" element={<PrepaymentCreateScreen />} />
      <Route path=":id/detail" element={<PrepaymentDetailScreen />} />
      <Route path=":id/edit" element={<PrepaymentEditScreen />} />
    </Routes>
  );
};

export default PrepaymentRouter;
